import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers/reducers';
import { initParams } from './reducers/params';
import { initData } from './reducers/data';
import App from './components/App/App';
import './index.css';

// the id of the div to render too
let appId = 'enav';

// get the ticker we're going to work with
initParams.ticker = window.location.href.split('/').pop().split('?')[0].toUpperCase();

// get the user's email from window param
if(window.clientParams) {
  console.log('have clientParams')
  if(window.clientParams.clientEmail) {
    initParams.email = window.clientParams.clientEmail;
    initParams.loggedIn = true;
    console.log(`logged in as: ${initParams.email}`)
  }
} else {
  console.log('not logged in')
}

// start it up if we have a hash since it'd be coming back from login/register flow
if(window.location.search.includes('enav=true')) {
  initParams.isStarted = true;
}

// overrides for local fun
// initParams.ticker = 'DON';
// initParams.loggedIn = true;
// initParams.email = 'testemail'
// initParams.isStarted = false;
initParams.latestRefreshSeconds = 5;
initParams.historyRefreshSeconds = 30;

// render
ReactDOM.render(
  <Provider
    store={createStore(
      reducers,
      { params: initParams, data: initData },
      applyMiddleware(thunk),
    )}
  >
    <App />
  </Provider>,
  document.getElementById(appId),
);



// WEBPACK FOOTER //
// ./src/index.js